import React, { useEffect, useRef, useState } from 'react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay } from 'swiper/modules';
import CardProductFeatured from './CardProductFeatured';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import StoreService from '../../Services/StoreService';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { useStoreContext } from '../../Contexts/StoreContext';
import { dataFakeForLoading } from '../../Utils/Constants/Product';

const FeaturedProducts = () => {

    const swiperFeaturedProductsRef = useRef<SwiperRef>(null);
    const { isMobile } = useLayoutContext();
    const [slidesPerView, setSlidesPerView] = useState(isMobile ? 1.08 : 3);
    const [ loading, setLoading ] = useState<boolean>(true);
    const { orderType, getOrderTypeIdByName } = useOrderTypeContext();
    const { currentStore } = useStoreContext();
    const [ featuredProducts, setFeaturedProducts ] = useState<any>(dataFakeForLoading);


    const loadFeaturedProducts = async () => {
        setLoading(true);
        try {
            const storeSevice = new StoreService(orderType);
            const payload = {
                store_id: currentStore.id,
                order_type: Number(getOrderTypeIdByName(orderType))
            }
            const data = await storeSevice.featuredProducts(payload);
            if (data) {
                setFeaturedProducts(data);
            } else {
                setFeaturedProducts([]);
            }
        } catch (error) {
            setFeaturedProducts(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadFeaturedProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const handleChangeSlide = (index: number) => {
        if (swiperFeaturedProductsRef.current && swiperFeaturedProductsRef.current.swiper) {
            swiperFeaturedProductsRef.current.swiper.slideTo(index);
        }
    }

    useEffect(() => {
        const checkSlidesPerView = () => {
            if (window.innerWidth < 640) {
                setSlidesPerView(1.08)
            } else if (window.innerWidth < 768) {
                setSlidesPerView(2.15)
            } else if (window.innerWidth < 1024) {
                setSlidesPerView(3.15)
            } else if (window.innerWidth < 1280) {
                setSlidesPerView(4.15)
            } else {
                setSlidesPerView(5.25)
            }
        }

        checkSlidesPerView()
        window.addEventListener('resize', () => {
            checkSlidesPerView()
        });

    }, []);

    if (isMobile) return null;

    return (
        <div id="boxFeaturedProducts" className='grid self-start gap-4'>
            <h2 className={`text-xl font-extrabold text-custom-primary mt-3 ml-2`}>Destaques</h2>  

            <Swiper
                ref={swiperFeaturedProductsRef}
                spaceBetween={0}
                modules={[Navigation, Pagination, Mousewheel, Keyboard, Autoplay]}
                slidesPerView={slidesPerView}
                centeredSlides={false}
                keyboard={{enabled: true}}
                className='grid w-full swiperBullets swiperNavigation'
                onSlideChange={(swiper: any) => {
                    handleChangeSlide(swiper.activeIndex)
                }}
                autoplay={{
                    delay: 3500,
                    disableOnInteraction: true,
                }}
                pagination={isMobile && {
                    clickable: true,
                        renderBullet: function (index: number, className: string) {
                        return '<span class="' + className + '"></span>';
                    },
                }}
                navigation={!isMobile}
                >
                {
                    featuredProducts.map((product: any, index: number) => (
                        <SwiperSlide
                            key={index} data-hash={`slide1${index}`}
                            className={'flex px-1 md:px-2 py-2'}
                            onClick={() => handleChangeSlide(index)}
                            >
                            <CardProductFeatured key={index} product={product} loading={loading} />
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}

export default FeaturedProducts;
